const functionURL = () => {
  const environment = process.env.NODE_ENV;
  if (environment === 'production') {
    return 'https://us-central1-gatepass-228e2.cloudfunctions.net/api';
  }
  return 'http://localhost:5001/gatepass-228e2/us-central1/api';
};

export default functionURL;
